import { render, staticRenderFns } from "./PageAdminBannerMedias.vue?vue&type=template&id=df327b9e&"
import script from "./PageAdminBannerMedias.vue?vue&type=script&lang=js&"
export * from "./PageAdminBannerMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df327b9e')) {
      api.createRecord('df327b9e', component.options)
    } else {
      api.reload('df327b9e', component.options)
    }
    module.hot.accept("./PageAdminBannerMedias.vue?vue&type=template&id=df327b9e&", function () {
      api.rerender('df327b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageAdminBannerMedias.vue"
export default component.exports